import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { ApiService } from '../../../service/api.service';
import { MatChipsModule } from '@angular/material/chips';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-sunset-info',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatButtonModule, MatIconModule, RouterLink, MatChipsModule],
  templateUrl: './sunset-info.component.html',
  styleUrl: './sunset-info.component.less'
})
export class SunsetInfoComponent {
  authors: any[] = [
    {
      name: 'Jaylin',
      id: 'Jaylin',
      avatar: ''
    }
  ]

  http = inject(HttpClient);
  constructor() {


    this.http.get('https://jar.games/api/scripts/authorList.php').subscribe((data: any) => {

      console.log(data);

      if (data && data.data) {
        this.authors = data.data;
      } else {
        this.authors = [];
      }
    }, (error) => {
      console.error('Failed to fetch authors:', error);
      this.authors = [];
    });
  }

  getAvatar(avatar: string) {
    if (avatar.startsWith("http")) {
      return avatar
    }
    return "https://jar.games"+avatar;
  }
}
